import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';


import {
    Box,
    Grid,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Divider,
    Alert,
    Backdrop,
    CircularProgress,
    Tooltip,
    IconButton
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import Pagination from '@mui/material/Pagination';
import PrintIcon from '@mui/icons-material/Print';
import axios from 'src/utils/axios';
import ExcelFileCreator from 'src/components/ExcelFileCreator';

const styles = {
    ul: {
        '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
                background: '#FF9800',
                color: 'white',
                borderRadius: '50%',
            },
        },
    },
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
    responsiveContainer: (theme) => ({
        marginTop: theme.spacing(3),
        [theme.breakpoints.between('md', 'lg')]: {
            maxHeight: '70vh',
            overflowX: 'hidden',
            overflowY: 'scroll'
        },
        [theme.breakpoints.down('sm')]: {
            maxHeight: '60vh',
            overflow: 'scroll'
        }
    }),
};

function EducationalExpertise({ EmployeeNr }) {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [educationalExpertiseData, setEducationalExpertiseData] = useState([]);

    useEffect(() => {
        getEducationalExpertiseData();
    }, []);


    const getEducationalExpertiseData = () => {
        setLoading(true);
        axios.get(`GetEmployeeEducationalExpertise/${EmployeeNr}`)
            .then((res) => {
                const data = res.data;
                if (!Array.isArray(data) || data.length === 0) {
                    setLoading(false);
                    setEducationalExpertiseData([]);
                    return;
                }
                setEducationalExpertiseData(res.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };


    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleExportClick = () => {
        setLoading(true);
        var exportData = [];
        educationalExpertiseData.map((row) => {
            exportData.push({
                "Uzmanlık Adı": row.ExpertiseName,
                "Atanma Tarihi": row.ExpertiseAssignmentDate,
                "Uzmanlığı Aldığı Eğitimin Adı": row.CourseName,
                "Eğitimin Başlama Tarihi": row.StartDate,
                "Eğitimin Bitiş Tarihi": row.EndDate,
                "Uzmanlık Durumu": row.ExpertiseStatus ? 'Aktif' : 'Pasif'
            });
        });
        ExcelFileCreator(exportData, `${EmployeeNr} - Eğitim Uzmanlıkları`);
        setLoading(false);
    };


    return (
        <>
            {
                loading ?
                    <Backdrop sx={styles.backdrop} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    : ''
            }
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid>
                        <Typography variant="h5">Eğitim Uzmanlıkları</Typography>
                    </Grid>
                    <Grid>
                        {educationalExpertiseData.length !== 0 && <Pagination
                            count={Math.ceil(educationalExpertiseData.length / 10)}
                            page={page}
                            onChange={handlePageChange}
                            variant="outlined"
                            sx={styles.ul}
                        />}
                    </Grid>
                    <Grid>
                        <Tooltip title="Yazdır">
                            <IconButton size="large" onClick={handleExportClick}>
                                <PrintIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
                <Divider sx={{ mb: 2 }} />
                <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
                    {educationalExpertiseData.length === 0 ? (
                        <Alert variant="outlined" severity="warning" sx={{ borderColor: theme.palette.warning.dark }}>
                            Bu çalışanın eğitim uzmanlığı bulunmamaktadır.
                        </Alert>) :
                        <TableContainer >
                            <Table stickyHeader aria-label="sticky table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Uzmanlık Adı</TableCell>
                                        <TableCell>Atanma Tarihi</TableCell>
                                        <TableCell>Uzmanlığı Aldığı Eğitimin Adı</TableCell>
                                        <TableCell>Eğitimin Başlama Tarihi</TableCell>
                                        <TableCell>Eğitimin Bitiş Tarihi</TableCell>
                                        <TableCell>Uzmanlık Durumu</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        educationalExpertiseData.map((row) => (
                                            <TableRow hover key={row.EducationalExpertiseNr}>
                                                <TableCell>{row.ExpertiseName}</TableCell>
                                                <TableCell>{row.ExpertiseAssignmentDate}</TableCell>
                                                <TableCell>{row.CourseName}</TableCell>
                                                <TableCell>{row.StartDate}</TableCell>
                                                <TableCell>{row.EndDate}</TableCell>
                                                <TableCell>{row.ExpertiseStatus ? 'Aktif' : 'Pasif'}</TableCell>
                                            </TableRow>
                                        ))
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>}
                </Box>
            </LocalizationProvider>
        </>
    );
}

export default EducationalExpertise;
